import React from 'react';
import { PopupWithMessageContainer, PopupWithMessageContent, PopupWithMessageFooter } from './styles';
import {Trans, useTranslation} from "react-i18next";
import {Modal} from "../Modal";
import {PopupIcon} from "../PopupIcon";
import {PrimaryButton} from "../PrimaryButton";
import {FeedbackTypes} from "../../app/interfaces";
import {isValidString} from "../../utils";

interface PopupWithMessageProps{
    isOpen: boolean,
    title?: string,
    subtitle?: string,
    buttonTitle?: string,
    buttonAction: Function,
    type?: FeedbackTypes,
    showFooter?: boolean
}

export const PopupWithMessage = ({isOpen, title, subtitle, buttonTitle, buttonAction, type='info', showFooter=true}: PopupWithMessageProps) => {

    const {t} = useTranslation()

    return <Modal isOpen={isOpen}>
        <PopupWithMessageContainer>
            <PopupWithMessageContent>
                <PopupIcon type={type}/>
                {title && <h1>{title}</h1>}
                {subtitle && <p>{subtitle}</p>}
                <PrimaryButton onClick={() => buttonAction()}>{isValidString(buttonTitle) ? buttonTitle : t('ok')}</PrimaryButton>
            </PopupWithMessageContent>
            {showFooter && <PopupWithMessageFooter>
                <Trans i18nKey="need_help_then_contact_us">
                    {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
                    <a href="mailto:support@companio.co"></a>
                </Trans>
            </PopupWithMessageFooter>}
        </PopupWithMessageContainer>
    </Modal>
}
